// LIBRARIES
import styled, { css } from "styled-components";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const TableContainer = styled.div`

`;

export const TableWrapper = styled.div`
  min-height: 590px;
`;

export const MUITable = styled(Table)`
  && {
    
  }
`;

export const MUITableHead = styled(TableHead)`
  && {
    top: 0;
  }
`;

export const MUITableBody = styled(TableBody)`
  && {
  }
`;
export const TextContainer = styled.div`
  display: block;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export const MUITableCell = styled(TableCell)`
  && {
    border-bottom: none;
    &.${tableCellClasses.head} {
      font-family: ${FONTS.newsharp};
      color: #F5F5F5;
      text-transform: uppercase;
      font-size: 16px;
      letter-spacing: 0.64px;
      font-weight: bold;
      padding: 10px 32px;
      text-align: ${(props) =>
    props.orientation ? props.orientation : `left`};
      &:first-of-type {
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
      }
      &:last-of-type {
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
      }
    }
    &.${tableCellClasses.body} {
      // border-bottom: 2px solid #EBEBEB;
      font-family: ${FONTS.montserrat};
      color: #1D1D26;
      font-size: 16px;
      padding: 26px 32px;
      letter-spacing: 0.64px;
      overflow-x: hidden;
      overflow-y: hidden;
      font-weight: medium;
      text-align: ${(props) =>
    props.orientation ? props.orientation : `left`};
    }
  }
`;

export const MUIActionTableCell = styled(TableCell)`
  && {
    &.${tableCellClasses.body} {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      font-family: ${FONTS.montserrat};
      color: #1D1D26;
      font-size: 16px;
      padding-right: 32px;
      letter-spacing: 0.64px;
      overflow-x: hidden;
      overflow-y: hidden;
      border-bottom: 0px solid transparent;
    }
  }
`;

export const MUITableRow = styled(TableRow)`
  && {
    height: 20px;
    width: 1760px;
    background-color: transparent;
    border-bottom: 2px solid #EBEBEB;
  }
`;

export const MUIHeadTableRow = styled(TableRow)`
  && {
    
    height: 40px;
    width: 1760px;
    background-color: #293462;
  }
`;

export const headerSpace = styled.div`
  height: 20px;
  background-color: green;
`;

export const RowSpace = styled.div`
  // height: 8px;
`;

export const ScrollableBodyContainer = styled.div`
  // max-width: 1760px;
  max-height: 640px;
  overflow: hidden;
  overflow-y: auto;
  // background-color: red;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: pink;
    border-radius: 10px;
    margin-block: 9px;
    margin-top: 90px;
  }
  ::-webkit-scrollbar-thumb {
    // background-color: red;
    border-radius: 10px;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  // margin-top: 5px;
  font-family: ${FONTS.montserrat};
`;

export const Dot = styled.div(
  ({ color }) => css`
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: ${color ? color : color};
    margin-bottom: 4px;
  `
);

export const StatusValue = styled.div(
  ({ color }) => css`
    color: ${color ? color : color};
    margin-left: 10px;
    font-size: 16px;
    padding-top: -20px;
  `
);

export const PaginationWrapper = styled.div`
  // position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  bottom: 50px;
`;


